import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logoMark from "../assets/brand/mark-primary.svg";

const Sidebar = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [isItemDropdownOpen, setItemDropdownOpen] = useState(false);
  const [isPlatterDropdownOpen, setPlatterDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true }); // Redirect to login page after logout
  };

  const navLinkClass = "block py-2 px-4 rounded text-sm hover:bg-white/10";
  const navButtonClass =
    "block py-2 px-4 w-full text-left rounded text-sm hover:bg-white/10";

  return (
    // No position:fixed - this is a normal flex child inside AdminLayout,
    // which is what lets every page stop hand-compensating with its own
    // ml-64/pl-[64px]. h-screen + shrink-0 keeps it pinned to full height
    // without taking it out of flow.
    <div className="bg-dark text-light h-screen w-64 shrink-0 p-4 flex flex-col">
      <Link to="/" className="flex items-center gap-2.5 mb-5">
        <img src={logoMark} alt="Ekhoni Khabo" className="w-8 h-8" />
        <span className="text-lg font-bold text-light">Ekhoni Khabo</span>
      </Link>
      <div className="mb-4 pb-4 border-b border-white/10">
        <p className="text-xs uppercase tracking-wide text-light/50">
          Signed in as
        </p>
        <p className="text-sm text-light">
          {user.firstName} {user.lastName}{" "}
          <span className="text-light/50">({user.role})</span>
        </p>
      </div>
      <ul className="space-y-0.5 flex-1">
        <li>
          <Link to="/" className={navLinkClass}>
            Dashboard
          </Link>
        </li>
        <li>
          <Link to="/orders" className={navLinkClass}>
            Orders
          </Link>
        </li>
        <li>
          <Link to="/customers" className={navLinkClass}>
            Customers
          </Link>
        </li>
        <li>
          <button
            onClick={() => setItemDropdownOpen(!isItemDropdownOpen)}
            className={navButtonClass}
          >
            Items
          </button>
          {isItemDropdownOpen && (
            <ul className="ml-4">
              <li>
                <Link to="/create-item" className={navLinkClass}>
                  Create Item
                </Link>
              </li>
              <li>
                <Link to="/update-item" className={navLinkClass}>
                  Update Item
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <button
            onClick={() => setPlatterDropdownOpen(!isPlatterDropdownOpen)}
            className={navButtonClass}
          >
            Custom Platters
          </button>
          {isPlatterDropdownOpen && (
            <ul className="ml-4">
              <li>
                <Link to="/create-platter" className={navLinkClass}>
                  Create platter
                </Link>
              </li>
              <li>
                <Link to="/update-platter" className={navLinkClass}>
                  Update platter
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <Link to="/mango" className={navLinkClass}>
            Mango
          </Link>
        </li>
        <li>
          <Link to="/restaurants" className={navLinkClass}>
            Restaurants
          </Link>
        </li>
        <li>
          <Link to="/categories" className={navLinkClass}>
            Categories
          </Link>
        </li>
        <li>
          <Link to="/sliders" className={navLinkClass}>
            Homepage Slider
          </Link>
        </li>
        {(user?.role === "super_admin" || user?.role === "admin") && (
          <>
            <li>
              <Link to="/staff" className={navLinkClass}>
                Staff
              </Link>
            </li>
            <li>
              <Link to="/settings" className={navLinkClass}>
                Settings
              </Link>
            </li>
            <li>
              <Link to="/create-admin" className={navLinkClass}>
                Create Admin
              </Link>
            </li>
          </>
        )}
      </ul>
      <button
        onClick={handleLogout}
        className="mt-4 pt-4 border-t border-white/10 flex items-center gap-2 py-2 px-4 w-full rounded text-sm font-semibold text-red-300 hover:bg-red-500/10 hover:text-red-200 transition"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 shrink-0">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
        Logout
      </button>
    </div>
  );
};

export default Sidebar;
